/**
 * QRMaps Design System - Geolocation Button Component
 *
 * Responsive map control button for getting user's current location
 *
 * Usage:
 *   <GeolocationButton
 *     onClick={getCurrentLocation}
 *     isLocating={isLocating}
 *     isMobile={isMobile}
 *     sidebarHeight={sidebarConfig.height}
 *     sidebarWidth={sidebarConfig.width}
 *   />
 */

import React from 'react';
import { StyledGeolocationButton } from './GeolocationButton.styled';

export const GeolocationButton = ({
  onClick,
  isLocating = false,
  isMobile = false,
  sidebarHeight = '0px',
  sidebarWidth = '0px',
  offsetBottom = '0px',
  title = 'Get current location',
  className,
}) => {
  return (
    <StyledGeolocationButton
      className={className}
      onClick={onClick}
      disabled={isLocating}
      $circular
      $size="md"
      $variant="secondary"
      $isMobile={isMobile}
      $sidebarHeight={sidebarHeight}
      $sidebarWidth={sidebarWidth}
      $offsetBottom={offsetBottom}
      title={title}
    >
      {isLocating ? '...' : '📍'}
    </StyledGeolocationButton>
  );
};

export default GeolocationButton;
